var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPrint = function SvgIconPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-print_svg__Capa_2",
    viewBox: "0 0 20.28 20.42"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-print_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.39 4.22H1.88C.84 4.22 0 5.06 0 6.1v7.3c0 1.04.84 1.88 1.88 1.88h1.38v-3.39c0-.95.77-1.71 1.71-1.71h10.32c.95 0 1.71.77 1.71 1.71v3.39h1.38c1.04 0 1.88-.84 1.88-1.88V6.1c0-1.04-.84-1.88-1.88-1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.99 11.44H5.28a.95.95 0 0 0-.95.95v7.08c0 .53.43.95.95.95h9.71c.53 0 .95-.43.95-.95v-7.08a.95.95 0 0 0-.95-.95m-1.7 6.8H7.12c-.27 0-.48-.22-.48-.48s.22-.48.48-.48h6.17c.27 0 .48.22.48.48s-.22.48-.48.48m0-1.83H7.12c-.27 0-.48-.22-.48-.48s.22-.48.48-.48h6.17c.27 0 .48.22.48.48s-.22.48-.48.48m0-1.83H8.75c-.27 0-.48-.22-.48-.48s.22-.48.48-.48h4.54c.27 0 .48.22.48.48s-.22.48-.48.48M14.24 0H6.03c-.94 0-1.7.76-1.7 1.7v1.75h11.61V1.7c0-.94-.76-1.7-1.7-1.7",
    fill: "#fff"
  }))));
};
export default SvgIconPrint;